import {
  FETCH_BANKS_REQUEST,
  FETCH_BANKS_SUCCESS,
  FETCH_BANKS_FAILURE,
  SAVE_BANK_REQUEST,
  SAVE_BANK_SUCCESS,
  SAVE_BANK_FAILURE,
  CHANGE_BANK_STATUS_REQUEST,
  CHANGE_BANK_STATUS_SUCCESS,
  CHANGE_BANK_STATUS_FAILURE,
} from "./actionTypes";

const initialState = {
  loading: false,
  banksList: [],
  data: null,
  error: null,
  success: false,
};

const bankMasterReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_BANKS_REQUEST:
      return { ...state, loading: true, error: null, success: false };

    case FETCH_BANKS_SUCCESS:
      return {
        ...state,
        loading: false,
        banksList: action.payload.data || [],
        success: false,
      };

    case FETCH_BANKS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case SAVE_BANK_REQUEST:
      return { ...state, loading: true, error: null, success: false };

    case SAVE_BANK_SUCCESS:
      return { ...state, loading: false, data: action.payload, success: true };

    case SAVE_BANK_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case CHANGE_BANK_STATUS_REQUEST:
      return { ...state, loading: true, error: null, success: false };

    case CHANGE_BANK_STATUS_SUCCESS:
      return { ...state, loading: false, success: true };

    case CHANGE_BANK_STATUS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default bankMasterReducer;
